module.exports = [
    {
        text: "Disabled",
        value: "Disabled"
    },
    {
        text: "JPEG2000Lossless",
        value: "JPEG2000Lossless"
    },
    {
        text: "JPEG2000Lossless (forced)",
        value: "ForcedJPEG2000Lossless"
    },
    {
        text: "JPEGLosslessProcess14_1",
        value: "JPEGLosslessProcess14_1"
    },
    {
        text: "JPEGLosslessProcess14_1 (forced)",
        value: "ForcedJPEGLosslessProcess14_1"
    }
];